import { render } from "./CommunitiesAssignment.vue?vue&type=template&id=7fd1671c&scoped=true"
import script from "./CommunitiesAssignment.vue?vue&type=script&lang=js"
export * from "./CommunitiesAssignment.vue?vue&type=script&lang=js"

import "./CommunitiesAssignment.vue?vue&type=style&index=0&id=7fd1671c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd1671c"]])

export default __exports__